"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarGroup = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const useWarning_1 = require("../../hooks/useWarning");
const Avatar_1 = require("./Avatar");
const AvatarGroup = ({ children, size = "md", max = children.length }) => {
    const { warn } = (0, useWarning_1.useWarning)();
    if (max < 0) {
        warn("AvatarGroup: `max` cannot be negative.");
    }
    const displayedAvatars = children.slice(0, max);
    const overflowCount = children.length - max;
    const overlapMargin = react_1.default.useMemo(() => ({
        marginLeft: (theme) => `calc(-1 * ${theme.space["spacing-3"]})`
    }), []);
    const groupStyles = react_1.default.useMemo(() => ({
        outline: "2px solid",
        outlineColor: "stroke-neutral-default",
        borderRadius: "radius-round"
    }), []);
    return (react_1.default.createElement(foundations_1.Box, { sx: { display: "flex", alignItems: "center" } },
        displayedAvatars.map((child, index) => (react_1.default.createElement(foundations_1.Box, { key: child.key || `avatar-${index}`, sx: Object.assign(Object.assign({}, (index !== 0 && overlapMargin)), groupStyles) },
            react_1.default.createElement(Avatar_1.Avatar, Object.assign({}, child.props, { size: size }))))),
        overflowCount > 0 && (react_1.default.createElement(foundations_1.Box, { sx: Object.assign(Object.assign({}, overlapMargin), groupStyles) },
            react_1.default.createElement(Avatar_1.Avatar, { key: `avatar-overflow-${overflowCount}`, size: size, alt: `${overflowCount} more Avatars` }, `+${overflowCount}`)))));
};
exports.AvatarGroup = AvatarGroup;
//# sourceMappingURL=AvatarGroup.js.map